export default __webpack_public_path__ + "static/media/timer_top.46f4e53f.svg";